var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faColumns, faPlus, faUndo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BBadge, BButton, BButtonGroup } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router/composables";
import { HistoriesFilters } from "@/components/History/HistoriesFilters";
import { Toast } from "@/composables/toast";
import { useHistoryStore } from "@/stores/historyStore";
import { useUserStore } from "@/stores/userStore";
import { localize } from "@/utils/localization";
import { withPrefix } from "@/utils/redirect";
import { errorMessageAsString } from "@/utils/simple-error";
import FilterMenu from "@/components/Common/FilterMenu.vue";
import HistoryList from "@/components/History/HistoryScrollList.vue";
import ActivityPanel from "@/components/Panels/ActivityPanel.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MultiviewPanel',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        library.add(faColumns, faPlus, faUndo);
        const filter = ref("");
        const showAdvanced = ref(false);
        const loading = ref(false);
        const isAnonymous = computed(() => useUserStore().isAnonymous);
        const historyStore = useHistoryStore();
        const { historiesLoading, currentHistoryId } = storeToRefs(historyStore);
        const pinnedHistoryCount = computed(() => {
            return Object.keys(historyStore.pinnedHistories).length;
        });
        const pinRecentTitle = computed(() => {
            if (pinnedHistoryCount.value > 0) {
                return localize("Reset selection to show 4 most recently updated histories instead");
            }
            else {
                return localize("Currently showing 4 most recently updated histories in Multiview");
            }
        });
        const pinRecentText = computed(() => {
            if (pinnedHistoryCount.value > 1) {
                return localize(`${pinnedHistoryCount.value} histories pinned. Click here to reset`);
            }
            else if (pinnedHistoryCount.value == 1) {
                return localize("1 history pinned. Click here to reset");
            }
            else {
                return localize("Select histories to pin to Multiview");
            }
        });
        function createAndPin() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    loading.value = true;
                    yield historyStore.createNewHistory();
                    if (!currentHistoryId.value) {
                        throw new Error("Error creating history");
                    }
                    if (pinnedHistoryCount.value > 0) {
                        historyStore.pinHistory(currentHistoryId.value);
                    }
                    router.push("/histories/view_multiple");
                }
                catch (error) {
                    console.error(error);
                    Toast.error(errorMessageAsString(error), "Error creating and pinning history");
                }
                finally {
                    loading.value = false;
                }
            });
        }
        /** Reset to _default_ state; showing 4 latest updated histories */
        function pinRecent() {
            historyStore.pinnedHistories = [];
            Toast.info("Showing the 4 most recently updated histories in Multiview. Pin histories to History Multiview by selecting them in the panel.", "History Multiview");
        }
        function setFilter(newFilter, newValue) {
            filter.value = HistoriesFilters.setFilterValue(filter.value, newFilter, newValue);
        }
        function userTitle(title) {
            if (isAnonymous.value == true) {
                return `Log in to ${title}`;
            }
            else {
                return title;
            }
        }
        return { __sfc: true, route, router, filter, showAdvanced, loading, isAnonymous, historyStore, historiesLoading, currentHistoryId, pinnedHistoryCount, pinRecentTitle, pinRecentText, createAndPin, pinRecent, setFilter, userTitle, faColumns, faPlus, faUndo, FontAwesomeIcon, BBadge, BButton, BButtonGroup, HistoriesFilters, withPrefix, FilterMenu, HistoryList, ActivityPanel };
    }
});
